import React from 'react'
import TooltipFFXIV from './TooltipFFXIV'

const TooltipWithIconFFXIV = ({
    text,
    children,
    position = 'right',
    size,
    className,
    warning = false,
}: {
    text?: string;
    children?: React.ReactNode;
    position?: 'left' | 'right';
    size?: 'normal' | 'small';
    className?: string;
    warning?: boolean;
}) => {
    const iconSizeClass = size === 'small' ? 'w-4 h-4 text-xs' : 'w-6 h-6 text-base';
    return (
        <div className={`group relative bg-[#292929] ${iconSizeClass} rounded-full flex items-center justify-center border-2 shadow shadow-black ${warning ? 'border-red-500' : 'border-[#7A7A7A]'}`}>
            <span className={`text-${warning ? 'white' : 'white'} text-shadow ${warning ? 'shadow-red-500' : 'shadow-yellow-500'}`}>!</span>
            <TooltipFFXIV position={position} className={className}>
                {text}
                {children}
            </TooltipFFXIV>
        </div>
    )
}

export default TooltipWithIconFFXIV